import { Suspense, lazy } from 'react';
import type { ComponentType, ReactElement } from 'react';
import { LoadingState } from '../components/states';

/**
 * Ленивая загрузка экранов маршрута.
 *
 * Run 02: бандл вырос до ~900 КБ одним файлом — при первом заходе браузер тянул
 * ВСЕ экраны системы, включая финансы, аналитику и портал, которые большинству
 * ролей вообще не показываются. Каждый маршрут теперь свой чанк; общий шелл,
 * вход и страница «не найдено» остаются в основном бандле, потому что нужны
 * сразу.
 *
 * Экраны экспортируются ИМЕНОВАННО, поэтому импорт разворачивается в default —
 * иначе React.lazy не примет модуль.
 */
export function lazyPage<K extends string>(
  loader: () => Promise<Record<K, ComponentType<Record<string, never>>>>,
  name: K,
): ReactElement {
  const Component = lazy(() =>
    loader().then((mod) => ({ default: mod[name] as ComponentType<Record<string, never>> })),
  );
  return (
    <Suspense fallback={<LoadingState lines={6} />}>
      <Component />
    </Suspense>
  );
}
